import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Tag, Star, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function UserClaims({ validClaims, claimsSectionRef }) {
  const navigate = useNavigate();
  return (
    <div ref={claimsSectionRef}>
      <h2 className="text-2xl font-bold text-slate-900 mb-4">Meus Cupons Ativos</h2>
      {validClaims.length > 0 ? (
        <div className="grid grid-cols-1 gap-4">
          {validClaims.map(claim => (
            <Card key={claim.claim_id} data-testid={`claim-${claim.claim_id}`} className="hero-card">
              <CardContent className="py-4">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="font-bold text-white">{claim.coupon?.title}</h3>
                    <p className="text-sm text-slate-200 font-mono">{claim.code}</p>
                    <p className="text-xs text-slate-300 mt-1">Expira: {new Date(claim.expires_at).toLocaleDateString('pt-BR')}</p>
                  </div>
                  <Button onClick={() => navigate(`/validate/${claim.claim_id}`)} className="bg-white/20 hover:bg-white/30 text-white border border-white/30" data-testid={`validate-btn-${claim.claim_id}`}>
                    Validar Compra
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card className="hero-card" data-testid="no-claims-card">
          <CardContent className="py-8 text-center">
            <Tag className="h-10 w-10 text-slate-300 mx-auto mb-3" />
            <p className="text-slate-200 font-medium">Nenhum cupom ativado ainda</p>
            <p className="text-sm text-slate-400 mt-1">Explore os cupons acima e ative o primeiro!</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}

export function UserTestimonials({ testimonials }) {
  return (
    <div className="mt-12" data-testid="testimonials-section">
      <div className="flex items-center gap-3 mb-6">
        <MessageSquare className="h-6 w-6 text-slate-600" />
        <h2 className="text-2xl font-bold text-slate-900">Depoimentos</h2>
      </div>
      {testimonials.length === 0 ? (
        <Card className="bg-white border border-slate-200">
          <CardContent className="py-12 text-center">
            <MessageSquare className="h-12 w-12 text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500">Ainda nenhum depoimento. Seja o primeiro a validar uma compra!</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {testimonials.map(t => (
            <Card key={t.validation_id} className="bg-white border border-slate-200 hover:shadow-md transition-shadow" data-testid={`testimonial-${t.validation_id}`}>
              <CardContent className="pt-6">
                <div className="flex items-center gap-3 mb-3">
                  {t.user_picture ? (
                    <img src={t.user_picture} alt="" className="w-10 h-10 rounded-full object-cover" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center">
                      <span className="text-slate-500 font-bold text-sm">{(t.user_name || 'U')[0]}</span>
                    </div>
                  )}
                  <div>
                    <p className="font-semibold text-slate-900 text-sm">{t.user_name || 'Usuario'}</p>
                    <div className="flex gap-0.5">
                      {[1, 2, 3, 4, 5].map(s => (
                        <Star key={s} className={`h-3.5 w-3.5 ${s <= t.rating ? 'fill-amber-400 text-amber-400' : 'text-slate-200'}`} />
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-slate-700 text-sm leading-relaxed mb-3">"{t.testimonial}"</p>
                {t.coupon && (
                  <div className="flex items-center gap-2 pt-3 border-t border-slate-100">
                    <Badge className="bg-slate-100 text-slate-700 border-slate-200 text-xs">{t.coupon.title}</Badge>
                    <Badge className="bg-slate-100 text-slate-600 border-slate-200 text-xs">{t.coupon.discount_percentage}% OFF</Badge>
                  </div>
                )}
                <p className="text-xs text-slate-400 mt-2">{new Date(t.validated_at).toLocaleDateString('pt-BR')}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
